import { type Theme, type Components } from '@mui/material/styles';

export const dialogCustomizations: Components<Theme> = {
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        background: 'black',
        boxShadow: theme.shadows[5],
        borderRadius: theme.shape.borderRadius,
        transition: 'all 0.3s ease-in-out',
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider || '#333'}`,
        padding: '22px',
      }),
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: '16px',
      },
    },
  },
};